const setApplications = (state, payload) => {
  state.applications = payload
}

export default {
  setApplications
}
